import { client } from 'pioneira-ui';
import guestHttpClient from '../../lib/http';

export default {
  namespaced: true,
  state: {
    situacaoOnboarding: null,
    revalidouCaf: false,
    hasInconsistencia: true,
  },
  mutations: {
    SET_SITUACAO_ONBOARDING(state, value) {
      state.situacaoOnboarding = value;
    },
    TOGGLE_REVALIDOU_CAF(state) {
      state.revalidouCaf = !state.revalidouCaf;
    },
    TOGGLE_INCONSISTENCIA(state) {
      state.hasInconsistencia = !state.hasInconsistencia;
    },
  },
  getters: {
    isSituacaoOnboardingAprovado(state) {
      return state.situacaoOnboarding == 'APROVADO';
    },
    revalidouCaf(state) {
      return state.revalidouCaf;
    },
  },
  actions: {
    gerarLinkOnboarding(context, payload) {
      return client
        .put(`/api/proposta/${payload.propostaId}/link-onboarding`, {
          documento: payload.documento,
          forcarCriarNovo: payload.forcarCriarNovo,
        })
        .catch((error) => {
          return error.response;
        });
    },

    async setSituacaoOnboarding(context, payload) {
      await context.commit('SET_SITUACAO_ONBOARDING', payload);
    },

    alterarRevalidouCaf(context) {
      context.commit('TOGGLE_REVALIDOU_CAF');
    },

    toggleInconsistencia(context) {
      context.commit('TOGGLE_INCONSISTENCIA');
    },

    pularEtapaOnboarding(context, id) {
      return client.put(`/api/proposta/${id}/onboarding`, {
        situacao: 'aprovado'
      });
    },

    getOnboardingByPropostaId(context, id) {
      return client.get(`/api/proposta/${id}/onboarding`);
    },

    storeHistoricoCaf(context, { situacao, propostaId }) {
      return client.post(`/api/proposta/${propostaId}/historico/caf`, {
        situacao,
      });
    },

    gerarToken(context, propostaId) {
      return client.post(`/webhooks/combate-fraude/gerar-token`, {
        propostaId,
      });
    },

    validarToken(context, token) {
      return client.post(`/webhooks/combate-fraude/validar-token`, {
        token,
      });
    },

    validateMobileToken(context, token) {
      return guestHttpClient.get(
        `/api/caf/validate-mobile-token?token=${token}`
      );
    },
  },
};
